export default __webpack_public_path__ + "static/media/FaceH.2c8392d5.png";